"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
// Malt process
gsap_1.gsap.utils.toArray('.js-malt-process').forEach((container) => {
    gsap_1.gsap.context(() => {
        gsap_1.gsap.set('.js-text', {
            autoAlpha: 0,
        });
        gsap_1.gsap.set('.js-bubble', {
            scale: 0,
        });
        const timeline = gsap_1.gsap.timeline({
            scrollTrigger: {
                trigger: container,
                start: 'top center',
            },
        });
        timeline.to('.js-text', {
            autoAlpha: 1,
            stagger: 0.15,
        });
        timeline.to('.js-bubble', {
            scale: 1,
            duration: 0.375,
            ease: 'back',
            stagger: 0.15,
        }, '<+=0.4');
    }, container);
});
// Collage image reveal
gsap_1.gsap.utils.toArray('.js-collage').forEach((container) => {
    gsap_1.gsap.context(() => {
        gsap_1.gsap.set('.js-reveal-me', {
            autoAlpha: 0,
        });
        gsap_1.gsap.to('.js-reveal-me', {
            autoAlpha: 1,
            stagger: 0.075,
            scrollTrigger: {
                trigger: container,
                start: 'top center',
            },
        });
    }, container);
});
// Pickling steps reveal animation
gsap_1.gsap.utils.toArray('.js-numbered-card').forEach((container) => {
    gsap_1.gsap.context(() => {
        gsap_1.gsap.set('.js-reveal-me', {
            autoAlpha: 0,
        });
        gsap_1.gsap.to('.js-reveal-me', {
            autoAlpha: 1,
            stagger: 0.125,
            scrollTrigger: {
                trigger: container,
                start: 'top center',
            },
        });
    }, container);
});
// Products reveal animation
gsap_1.gsap.utils.toArray('.js-product-card').forEach((container) => {
    gsap_1.gsap.context(() => {
        gsap_1.gsap.set('.product-card__image, .product-card__content', {
            opacity: 0,
        });
        const timeline = gsap_1.gsap.timeline({
            scrollTrigger: {
                trigger: container,
                start: 'top center',
            },
        });
        timeline.fromTo('.product-card__image', {
            duration: 0.2,
            scale: 0.9,
        }, {
            opacity: 1,
            scale: 1,
        });
        timeline.fromTo('.product-card__content', {
            duration: 0.2,
            scale: 0.9,
        }, {
            opacity: 1,
            scale: 1,
        }, '<+=0.15');
    }, container);
});
